import script from "./Datepicker.vue?vue&type=script&setup=true&lang=js"
export * from "./Datepicker.vue?vue&type=script&setup=true&lang=js"

import "./Datepicker.vue?vue&type=style&index=0&id=2bc1aaa5&lang=scss"

const __exports__ = script;

export default __exports__